export const getRiskStatus = (stealer) => {
  if (!stealer) return { status: "unknown", label: "Unknown", color: "gray" };

  let hasPasswords = false;
  let hasCookies = false;
  let hasCreditCards = false;

  // Check if this is a full stealer object with separate passwords/creditcards arrays
  if (stealer.passwords && stealer.passwords.length > 0) {
    hasPasswords = true;
  }

  if (stealer.creditcards && stealer.creditcards.length > 0) {
    hasCreditCards = true;
  }

  if (stealer.cookies && stealer.cookies.length > 0) {
    hasCookies = true;
  }

  // Also check the results array if it exists
  const results = stealer.results || stealer;

  // Check through all results if it's an array
  if (Array.isArray(results)) {
    for (const result of results) {
      if (result.results) {
        // Check for passwords/credentials
        if (
          (result.results.usernamesAndDomains && result.results.usernamesAndDomains.length > 0) ||
          (result.results.combosAndDomains && result.results.combosAndDomains.length > 0) ||
          (result.results.passwordsApps && result.results.passwordsApps.length > 0) ||
          (result.results.combos && result.results.combos.length > 0)
        ) {
          hasPasswords = true;
        }

        // Check for cookies
        if (result.results.cookies && result.results.cookies.length > 0) {
          hasCookies = true;
        }

        // Check for credit cards
        if (result.results.creditcards && result.results.creditcards.length > 0) {
          hasCreditCards = true;
        }
      }
    }
  } else if (results.results) {
    // Handle case where results is a single object
    const resultData = results.results;

    // Check for passwords/credentials
    if (
      (resultData.usernamesAndDomains && resultData.usernamesAndDomains.length > 0) ||
      (resultData.combosAndDomains && resultData.combosAndDomains.length > 0) ||
      (resultData.passwordsApps && resultData.passwordsApps.length > 0) ||
      (resultData.combos && resultData.combos.length > 0)
    ) {
      hasPasswords = true;
    }

    // Check for cookies
    if (resultData.cookies && resultData.cookies.length > 0) {
      hasCookies = true;
    }

    // Check for credit cards
    if (resultData.creditcards && resultData.creditcards.length > 0) {
      hasCreditCards = true;
    }
  }

  // Check if reason is 'password' or 'credentials' as a fallback
  if (stealer.reason === "password" || stealer.reason === "credentials") {
    hasPasswords = true;
  } else if (stealer.reason === "cookies") {
    hasCookies = true;
  } else if (stealer.reason === "creditcards") {
    hasCreditCards = true;
  }

  // Determine risk level
  if (hasCreditCards || hasPasswords) {
    return { status: "high", label: "High Risk", color: "red" };
  } else if (hasCookies) {
    return { status: "medium", label: "Medium Risk", color: "orange" };
  } else {
    return { status: "low", label: "Low Risk", color: "#FFD700" }; // Yellow
  }
};
